exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".apple-icon {\n  margin-bottom: 5px;\n}\n", ""]);
